import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import api from '@/api';
import { MessageInput } from '@/messages/MessageInput';
import { MessagesSidebarLayout } from '@/messages/MessagesSidebarLayout';
import { MessagesContainer } from '@/messages/messagesStyles';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/messages/compose',
)({
  component: MessagesComposeRoute,
  validateSearch: (search): { r?: number } => ({
    r: search.r ? Number(search.r) : undefined,
  }),
});

function MessagesComposeRoute() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const navigate = useNavigate();
  const { r: recipientId } = Route.useSearch();

  const { mutateAsync: createThread } = api.createThread.useMutation();

  const handleSendMessage = async (message: string) => {
    if (!recipientId) return;
    // Find-or-create the 1:1 thread with this recipient, then jump into it.
    const { thread_id } = await createThread({
      body: { recipient_id: recipientId, content: message },
    });
    await api.listMessageThreads.invalidateQueries();
    navigate({
      to: '/members/$memberId/messages/view/$threadId/',
      params: { memberId, threadId: `${thread_id}` },
    });
  };

  return (
    <MessagesSidebarLayout
      onThreadClick={(thread) =>
        navigate({
          to: '/members/$memberId/messages/view/$threadId/',
          params: { memberId, threadId: `${thread.id}` },
        })
      }
    >
      <ComposeHeader>
        <ComposeHeaderTop>{t('wbs.new-message')}</ComposeHeaderTop>
      </ComposeHeader>

      <MessagesContainer />

      <MessageInput onSend={handleSendMessage} buttonLabel={t('wbs.send')} />
    </MessagesSidebarLayout>
  );
}

const ComposeHeader = styled.div`
  border-bottom: 1px solid var(--grey-300);
  display: flex;
  flex-direction: column;
`;

const ComposeHeaderTop = styled.div`
  border-bottom: 1px solid var(--grey-300);
  color: var(--black);
  font-family: var(--raleway);
  font-size: 13px;
  font-weight: 500;
  padding: 20px 20px;
`;
